import { bestSellers, newArrivals } from '../../../mocks/products';

export default function DashboardOverview() {
  const totalProducts = bestSellers.length + newArrivals.length;
  
  const stats = [
    {
      icon: 'ri-shopping-bag-line',
      label: 'Total Products',
      value: totalProducts.toString(),
      change: '+12%',
      changeType: 'increase',
      bgColor: 'bg-blue-50',
      iconColor: 'text-blue-600',
    },
    {
      icon: 'ri-grid-line',
      label: 'Categories',
      value: '5',
      change: 'Active',
      changeType: 'neutral',
      bgColor: 'bg-purple-50',
      iconColor: 'text-purple-600',
    },
    {
      icon: 'ri-image-line',
      label: 'Banner Slides',
      value: '2',
      change: 'Active',
      changeType: 'neutral',
      bgColor: 'bg-orange-50',
      iconColor: 'text-orange-600',
    },
    {
      icon: 'ri-shopping-cart-line',
      label: 'Orders Today',
      value: '24',
      change: '+8%',
      changeType: 'increase',
      bgColor: 'bg-green-50',
      iconColor: 'text-green-600',
    },
  ];

  const quickActions = [
    {
      icon: 'ri-add-circle-line',
      label: 'Add New Product',
      description: 'Create a new product listing',
      link: '/pheee/products',
      color: 'text-[#EF579A]',
    },
    {
      icon: 'ri-image-add-line',
      label: 'Manage Banners',
      description: 'Update promotional banners',
      link: '/pheee/banners',
      color: 'text-orange-600',
    },
    // {
    //   icon: 'ri-settings-3-line',
    //   label: 'Site Settings',
    //   description: 'Configure site content',
    //   link: '/pheee/settings',
    //   color: 'text-purple-600',
    // },
  ];

  const recentActivity = [
    { action: 'New product added', item: 'Floral Summer Dress', time: '2 hours ago', icon: 'ri-add-line', color: 'text-green-600' },
    { action: 'Product updated', item: 'Casual White Tee', time: '5 hours ago', icon: 'ri-edit-line', color: 'text-blue-600' },
    { action: 'Banner changed', item: 'Summer Sale Banner', time: '1 day ago', icon: 'ri-image-line', color: 'text-orange-600' },
    { action: 'Category edited', item: 'Dresses', time: '2 days ago', icon: 'ri-edit-2-line', color: 'text-purple-600' },
    { action: 'Product deleted', item: 'Old Collection Item', time: '3 days ago', icon: 'ri-delete-bin-line', color: 'text-red-600' },
  ];

  return (
    <div className="space-y-6">
      {/* Stats Grid */}
      {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {stats.map((stat, index) => (
          <div key={index} className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg transition-shadow">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <p className="text-sm text-gray-600 mb-1">{stat.label}</p>
                <h3 className="text-3xl font-bold text-gray-900 mb-2">{stat.value}</h3>
                <span
                  className={`text-xs font-medium ${
                    stat.changeType === 'increase' ? 'text-green-600' : 'text-gray-500'
                  }`}
                >
                  {stat.change}
                </span>
              </div>
              <div className={`w-12 h-12 ${stat.bgColor} rounded-lg flex items-center justify-center`}>
                <i className={`${stat.icon} text-2xl ${stat.iconColor}`}></i>
              </div>
            </div>
          </div>
        ))}
      </div> */}

      {/* Quick Actions */}
      <div className="bg-white rounded-xl p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-900 mb-4">Quick Actions</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {quickActions.map((action, index) => (
            <a
              key={index}
              href={action.link}
              className="flex items-start space-x-4 p-4 rounded-lg border border-gray-200 hover:border-[#EF579A] hover:shadow-md transition-all cursor-pointer group"
            >
              <div className="w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center group-hover:bg-[#EF579A]/10 transition-colors">
                <i className={`${action.icon} text-2xl ${action.color} group-hover:text-[#EF579A]`}></i>
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-gray-900 mb-1 whitespace-nowrap">{action.label}</h4>
                <p className="text-sm text-gray-600">{action.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Recent Activity */}
      {/* <div className="bg-white rounded-xl p-6 border border-gray-200">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-gray-900">Recent Activity</h3>
          <button className="text-sm text-[#EF579A] hover:text-[#d94a87] font-medium cursor-pointer whitespace-nowrap">
            View All
          </button>
        </div>
        <div className="space-y-4">
          {recentActivity.map((activity, index) => (
            <div key={index} className="flex items-start space-x-4 pb-4 border-b border-gray-100 last:border-0 last:pb-0">
              <div className="w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${activity.icon} text-lg ${activity.color}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-900">
                  <span className="font-medium">{activity.action}:</span> {activity.item}
                </p>
                <p className="text-xs text-gray-500 mt-1">{activity.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
}
